module.exports = __webpack_public_path__ + "static/media/Construction_Home_Loans.e71a72ba.png";